import * as z from 'zod';

import { LosId } from '../../BrandedIds';
import { DateString } from '../fields';

export const CreateLoanNoteRow = z.object({
  loanId: LosId,
  author: z
    .string()
    .optional()
    .describe(
      'Optional name or email of the loan note author. If an email address is used, the note will check if it belongs to a Willow user.',
    ),
  date: DateString.optional().describe('Date the note was created. If left blank, today is used as the creation date.'),
  note: z.string().describe('The note content'),
  pin: z.boolean().optional().describe('Optional flag to pin the note to the loan'),
});
export type CreateLoanNoteRow = z.infer<typeof CreateLoanNoteRow>;

export const CREATE_LOAN_NOTE_ROW_REQUIRED_FIELDS = Object.keys(CreateLoanNoteRow.shape).filter(
  (key) => !CreateLoanNoteRow.shape[key as keyof typeof CreateLoanNoteRow.shape].isOptional(),
);
